function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M30.814,14.74h-4.64l5.441-5.449c0.443-0.439,0.443-1.154,0-1.595c-0.44-0.438-1.157-0.438-1.597,0 l-7.04,7.044h-2.278V2.257h10.113c0.63,0,1.135-0.511,1.135-1.126C31.949,0.505,31.444,0,30.814,0H19.575 c-0.622,0-1.128,0.505-1.128,1.131v14.73c0,0.633,0.506,1.131,1.128,1.131h1.14l-4.853,4.854c-0.908-0.548-1.905-0.951-2.962-1.19 c2.043-0.911,3.465-2.95,3.465-5.322c0-3.211-2.61-5.83-5.826-5.83c-3.213,0-5.826,2.619-5.826,5.83 c0,2.372,1.425,4.411,3.471,5.322c-4.648,1.067-8.133,5.247-8.133,10.21C0.051,31.494,0.563,32,1.178,32 c0.628,0,1.134-0.506,1.134-1.135c0-4.536,3.688-8.23,8.228-8.23c1.314,0,2.564,0.313,3.662,0.869l-3.648,3.652 c-0.441,0.449-0.441,1.158,0,1.602c0.22,0.209,0.513,0.324,0.802,0.324c0.283,0,0.578-0.106,0.794-0.324l3.95-3.947 c1.636,1.501,2.665,3.666,2.665,6.055c0,0.629,0.506,1.135,1.127,1.135c0.633,0,1.139-0.506,1.139-1.135 c0-3.016-1.288-5.742-3.334-7.66l6.218-6.213h6.901c0.63,0,1.135-0.498,1.135-1.131C31.949,15.238,31.444,14.74,30.814,14.74z  M6.974,15.333c0-1.97,1.599-3.575,3.565-3.575c1.968,0,3.563,1.605,3.563,3.575c0,1.962-1.595,3.563-3.563,3.563 C8.572,18.896,6.974,17.295,6.974,15.333z"
});

var SvgCursoIcon = function SvgCursoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCursoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cursoIcon.7e7e6a7b.svg";
export { ForwardRef as ReactComponent };